import { WebAgentLoginConfig } from '@a365/webagent-login';

export const backwardsCompatibility = {
    noReasonCodeInProfile: {
        versionFrom: {
            major: 1,
            minor: 22
        }
    },
    textHandlingUccAndSkillWildcardSearch: {
        versionFrom: {
            major: 1,
            minor: 21
        }
    },
    terminateEndpoint: {
        versionFrom: {
            major: 1,
            minor: 26
        }
    },
    closeConversationAfterTransfer: {
        versionFrom: {
            major: 1,
            minor: 28
        }
    },
    skillTransferAudioCalls: {
        versionFrom: {
            major: 1,
            minor: 19
        }
    }
};

export class AppConfig implements WebAgentLoginConfig {
    version?: string;
    adminPortalUrl: string;
    appInsightsConfig: {
        connectionString: string;
    };
    oidcConfig: {
        baseUrl: string;
        clientId: string;
        tokens: {
            default: {
                scopes: string[];
            },
            graph: {
                scopes: string[];
                endpointUri: string;
            },
            acs?: {
                endpointUri: string;
            }
        }
    };
    toastTimeout: number;
    messageTimeout: number;
    logWebAgentMessages: boolean;
    heartbeatEnabled: boolean;
    translationsUrl: string;
    webagentServerUrl: string;
}

let resolveAppConfigPromise;
export const appConfigPromise: Promise<AppConfig> = new Promise(resolve => {
    resolveAppConfigPromise = resolve;
});

export function loadAppConfig(environment): Promise<AppConfig> {

    const jsonPublicFile = `assets/config/${environment}.json`;
    const jsonPrivateFile = `assets/config/${environment}.private.json`;
    const request = {
        headers: { Accept: 'application/json' },
        method: 'GET'
    };

    return Promise.all([
        fetch(jsonPublicFile, request),
        fetch(jsonPrivateFile, request)
    ]).then(async ([ publicJsonResponse, privateJsonResponse ]) => {
        const publicJson = await publicJsonResponse.json();
        const privateJson = await privateJsonResponse.json();
        return Object.assign(publicJson, privateJson);
    }).then(appConfigJson => {
            const appConfig = toAppConfig(appConfigJson);
            resolveAppConfigPromise(appConfig);
            return appConfig;
        })
        .catch((response: any) => {
            throw new Error(`Could not load file(s) '${jsonPublicFile}' and/or '${jsonPrivateFile}': ${JSON.stringify(response)}`);
        });
}

function toAppConfig(appConfigJson): AppConfig {
    return Object.assign(new AppConfig(), appConfigJson);
}
